import { render } from "./BaseGalleryGridItem.vue?vue&type=template&id=0074d543&scoped=true"
import script from "./BaseGalleryGridItem.vue?vue&type=script&lang=js"
export * from "./BaseGalleryGridItem.vue?vue&type=script&lang=js"

import "./BaseGalleryGridItem.vue?vue&type=style&index=0&id=0074d543&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0074d543"]])

export default __exports__